module.exports = __webpack_public_path__ + "img/29a-indicadores-analises-por-situacao.874024ed.png";